import { render, staticRenderFns } from "./caseList.vue?vue&type=template&id=2722c624&"
import script from "./caseList.vue?vue&type=script&lang=js&"
export * from "./caseList.vue?vue&type=script&lang=js&"
import style0 from "./caseList.vue?vue&type=style&index=0&id=2722c624&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports